// extracted by css-extract-rspack-plugin
export default {"toast":"kzCNag","corner":"iP9yvh","countdown":"d9jyuW","iconButton":"tbeRKF"};